import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { user } from '@app/_shared/_models/user';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';
import { ForumInscriptionService } from '@app/_shared/_services/forum/inscription.service';
import { UsersService } from '@app/_shared/_services/users.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-cllajinscriptionuser',
  templateUrl: './cllajinscriptionuser.component.html',
  styleUrls: ['./cllajinscriptionuser.component.scss'],
})
export class CllajinscriptionuserComponent implements OnInit {
  @Output() onNextStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPrevStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  dateMin;
  now = new Date();
  formCheck = {
    prenom: null,
    nom: null,
    // adresse: null,
    dateNaissance: null,
    ville: null,
    quartier: null,
    pays: null,
    // codePostal: null,
    email: null,
    telephone: null,
    cguAccepted: null,
    csp: null,
  };

  cspList = [
    'CDD (Contrat aidé ...)',
    'CDI',
    "Contrat d'avenir",
    'CUI',
    'CAE DOM',
    'Intérimaire',
    "Demandeur d'emploi : inscrit pôle emploi ou mission locale",
    'Etudiant : Prépa, IFMES, BTS, école, boursier, irav ...',
    'Scolaire',
    'En formation',
    'Sans emploi : non inscrit pôle emploi',
    'Travailleur indépendant : créateur entreprise, artisan',
    "Travailleur porteur d'un handicape",
    'Apprentis',
    'TTS (Titre de travail simplifié)',
    'Contrat volontaire ( RSMA, Service civique ...)',
    'Garanties jeunes',
    'Autre',
  ];
  territoireList = [
    {
      name: 'Martinique',
      villes: [
        { name: 'Ajoupa Bouillon', quartiers: [
                      {name:"Abandonne"},
                      {name:"Adinet"},
                      {name:"Bourg"},
                      {name:"Centre ville"},
                      {name:"Croix Laurence"},
                      {name:"Deschamps"},
                      {name:"Dufailly"},
                      {name:"Grande Savane"},
                      {name:"la Capote"},
                      {name:"la Racine"},
                      {name:"Mille Pas"},
                      {name:"Mondzi"},
                      {name:"Ravine des Saints"},
                      {name:"Rosalie"},
                      {name:"Semaine"},
                      {name:"Sence"},
                      {name:"Vieux Cacao"},
                      {name:"Autre"},
        ] },
        { name: 'Basse Pointe', quartiers: [
                      {name :"Bourg"},
                      {name :"Centre ville"},
                      {name :"Chalvet"},
                      {name :"Eyma"},
                      {name :"Hackaert"},
                      {name :"Hauteur bourbon"},
                      {name :"Hauteur Dumas"},
                      {name :"La falaise"},
                      {name :"La lave"},
                      {name :"Magdelonnette"},
                      {name :"Moulin l'etang"},
                      {name :"Pecoul"},
                      {name :"Potiche"},
                      {name:"Autre"},

        ] },
        { name: 'Bellefontaine', quartiers: [
                  {name:"Bois Desir"},
	    	          {name:"Bourg"},
	    	          {name:"Canal"},
	    	          {name:"Centre ville"},
	    	          {name:"Cheval Blanc"},
	    	          {name:"Duvallon"},
	    	          {name:"Fond laillet"},
	    	          {name:"Fourcher"},
	    	          {name:"Jeannot"},
	    	          {name:"morne roches"},
	    	          {name:"Verrier"},
	    	          {name:"Autre"},
        ] },
        { name: 'Case Pilote', quartiers: [
                  {name:"Batterie"},
	    	          {name:"Bourg"},
	    	          {name:"Case Brulee"},
	    	          {name:"Centre ville"},
	    	          {name:"Choiseul"},
	    	          {name:"Fond boucher"},
	    	          {name:"fond bourlet"},
	    	          {name:"fourniol"},
	    	          {name:"Grande trace"},
	    	          {name:"haut de maniba"},
	    	          {name:"La demarche"},
	    	          {name:"Les abymes"},
	    	          {name:"Maniba"},
	    	          {name:"micolo"},
	    	          {name:"Morne acajou"},
	    	          {name:"Morne Capot"},
	    	          {name:"Morne obely"},
	    	          {name:"Plaisance"},
	    	          {name:"Autre"},
        ] },
        { name: 'Ducos', quartiers: [
	    	          {name:"Baie des Mulets"},
	    	          {name:"Barrington"},
	    	          {name:"beauville"},
	    	          {name:"Bourg"},
	    	          {name:"Canal"},
	    	          {name:"Centre ville"},
	    	          {name:"Chemin de Fer"},
	    	          {name:"citron"},
	    	          {name:"Dallas"},
	    	          {name:"Durivage"},
	    	          {name:"Fenelon"},
	    	          {name:"Fond bruler"},
	    	          {name:"fond d'orange"},
	    	          {name:"Fond savane"},
	    	          {name:"Genipa"},
	    	          {name:"Grande rochelle"},
	    	          {name:"Grande savane"},
	    	          {name:"La beauville"},
	    	          {name:"LA body"},
	    	          {name:"La cadeau"},
	    	          {name:"La chaissing"},
	    	          {name:"La cheneaux"},
	    	          {name:"La leandre"},
	    	          {name:"la marie"},
	    	          {name:"La Regale"},
	    	          {name:"La roman"},
	    	          {name:"Lazaret"},
	    	          {name:"Le repos"},
	    	          {name:"Lourdes"},
	    	          {name:"morne carette"},
	    	          {name:"Morne Coco"},
	    	          {name:"Morne lapointe"},
	    	          {name:"Morne vert"},
	    	          {name:"Pays noye"},
	    	          {name:"Petit paradis"},
	    	          {name:"Petit parc"},
	    	          {name:"Petite Cocotte"},
	    	          {name:"Petite rochelle"},
	    	          {name:"Pignol"},
	    	          {name:"Riviere pierre"},
	    	          {name:"Saint pierre"},
	    	          {name:"Syndic"},
	    	          {name:"Vaudrancourt"},
	    	          {name:"Vert pré"},
	    	          {name:"ZAC du bac"},
	    	          {name:"Autre"},

        ] },
        { name: 'Fonds Saint Denis', quartiers: [
	    	          {name:"Bourg"},
	    	          {name:"Morne des Cadets"},
	    	          {name:"Autre"},
        ] },
        { name: 'Fort de France', quartiers: [
	    	          {name:"Absalon"},
	    	          {name:"Ancienne route de schoelcher"},
	    	          {name:"Avenue Maurice Bishop"},
	    	          {name:"Baie des Tourelles"},
	    	          {name:"Balata "},
	    	          {name:"bareme"},
	    	          {name:"Bas maternité"},
	    	          {name:"Bellevue"},
	    	          {name:"berge debriand"},
	    	          {name:"bois boyer"},
	    	          {name:"bois thibault"},
	    	          {name:"bon air"},
	    	          {name:"Bourg"},
	    	          {name:"Bª kannal"},
	    	          {name:"Calvaire"},
	    	          {name:"Canal Alaric"},
	    	          {name:"Centre Ville"},
	    	          {name:"Centre ville"},
	    	          {name:"Chateauboeuf"},
	    	          {name:"cite bonaire"},
	    	          {name:"cité calebasse"},
	    	          {name:"cité dillon"},
	    	          {name:"Cité ozanam"},
	    	          {name:"citron"},
	    	          {name:"clairiere"},
	    	          {name:"clemenceau"},
	    	          {name:"cluny"},
	    	          {name:"Colson"},
	    	          {name:"coridon"},
	    	          {name:"Cour campeche"},
	    	          {name:"crozanville"},
	    	          {name:"Dallas"},
	    	          {name:"Debriant"},
	    	          {name:"Desaix"},
	    	          {name:"Desbrosses"},
	    	          {name:"Desbrosses Tivoli"},
	    	          {name:"Desclieux"},
	    	          {name:"Descossieres"},
	    	          {name:"desrochers"},
	    	          {name:"didier"},
	    	          {name:"dillon"},
	    	          {name:"Dillon Nord"},
	    	          {name:"Dillon Sud"},
	    	          {name:"eaux  découpées"},
	    	          {name:"entraide"},
	    	          {name:"ermitage"},
	    	          {name:"Etang z'abricot"},
	    	          {name:"Fantaisie"},
	    	          {name:"Faubourg la Camille"},
	    	          {name:"Floreal"},
	    	          {name:"Fond comat"},
	    	          {name:"Fond Lada"},
	    	          {name:"Godissard"},
	    	          {name:"grosse roche"},
	    	          {name:"hauts du port"},
	    	          {name:"Jambette"},
	    	          {name:"jambette 2"},
	    	          {name:"Jules Beaunes Tivoli"},
	    	          {name:"KERLYS"},
	    	          {name:"La Carrire"},
	    	          {name:"la folie"},
	    	          {name:"La Médaille"},
	    	          {name:"La Meynard"},
	    	          {name:"Langellier"},
	    	          {name:"martin Luther King"},
	    	          {name:"Montgerald"},
	    	          {name:"Morne calebasse"},
	    	          {name:"Morne dillon"},
	    	          {name:"Morne laurent Tivoli"},
	    	          {name:"Morne morissot"},
	    	          {name:"Morne Pichevin"},
	    	          {name:"morne vannier"},
	    	          {name:"Morne Vente"},
	    	          {name:"moutte"},
	    	          {name:"pavé"},
	    	          {name:"Petite Cocotte"},
	    	          {name:"petite zac"},
	    	          {name:"Plateau Fofo est"},
	    	          {name:"plateau tiberge"},
	    	          {name:"pointe de la vierge"},
	    	          {name:"pointe des carriers"},
	    	          {name:"Pointe Des Grives"},
	    	          {name:"pointe des ngres"},
	    	          {name:"pointe simon"},
	    	          {name:"pont de chaines"},
	    	          {name:"Pont viard"},
	    	          {name:"Populo"},
	    	          {name:"Post Colon"},
	    	          {name:"Post colon tivoli"},
	    	          {name:"ravine blanche"},
	    	          {name:"ravine bouillée"},
	    	          {name:"ravine vilaine"},
	    	          {name:"redoute"},
	    	          {name:"renéville"},
	    	          {name:"Reunion"},
	    	          {name:"Rive droite levassor"},
	    	          {name:"rivire l'or"},
	    	          {name:"Rivire roche"},
	    	          {name:"rodate"},
	    	          {name:"Rodate tivoli"},
	    	          {name:"route de balata"},
	    	          {name:"Route de la folie"},
	    	          {name:"route de moutte"},
	    	          {name:"Route des religieuse"},
	    	          {name:"Sainte Catherine"},
	    	          {name:"Sainte therese"},
	    	          {name:"Tartenson"},
	    	          {name:"Terres Sainville"},
	    	          {name:"Texaco"},
	    	          {name:"tivoli"},
	    	          {name:"Toquade"},
	    	          {name:"Tourtet"},
	    	          {name:"TRENELLE"},
	    	          {name:"TSF Canal Alaric"},
	    	          {name:"vieux moulin"},
	    	          {name:"voix de ville"},
	    	          {name:"volga plage"},
	    	          {name:"volga sud"},
	    	          {name:"zac chateauboeuf"},
	    	          {name:"zac de l'etang z'abricot"},
	    	          {name:"ZAC de rivire roche"},
	    	          {name:"zac est"},
	    	          {name:"Autre"},


        ] },
        { name: 'Grand Rivière', quartiers: [
          {name:"Bourg"},
          {name:"Autre"},] },
        { name: 'Gros Morne', quartiers: [
                  {name:"Bagatelle"},
	    	          {name:"Bas 2 Terres"},
	    	          {name:"Belle Terre"},
	    	          {name:"bois l_zarde"},
	    	          {name:"Bourg"},
	    	          {name:"Calvaire"},
	    	          {name:"Centre ville"},
	    	          {name:"Cote d'or"},
	    	          {name:"croix girin"},
	    	          {name:"Croix jubile"},
	    	          {name:"Croix odillon"},
	    	          {name:"Denel"},
	    	          {name:"Dessaint"},
	    	          {name:"Deux terres"},
	    	          {name:"dominant"},
	    	          {name:"Dosithee"},
	    	          {name:"Dumaine"},
	    	          {name:"glotin"},
	    	          {name:"Hauteur Four A Chaux"},
	    	          {name:"La birot"},
	    	          {name:"La fraicheur"},
	    	          {name:"La nazaire"},
	    	          {name:"La tracee"},
	    	          {name:"La vierge"},
	    	          {name:"Les flamboyants"},
	    	          {name:"Magnan"},
	    	          {name:"Petite lezarde"},
	    	          {name:"Providence"},
	    	          {name:"ravine plate"},
	    	          {name:"Riviere lezarde 1"},
	    	          {name:"RIViviere lezarde 2"},
	    	          {name:"rivire pomme"},
	    	          {name:"SINAI"},
	    	          {name:"Tamarins"},
	    	          {name:"Autre"},
        ] },
        { name: 'La Trinité', quartiers: [
	    	          {name:"Anse Belgrade"},
	    	          {name:"Anse Bellune"},
	    	          {name:"Anse l'Etang"},
	    	          {name:"Anse Spourtourne"},
	    	          {name:"Bac"},
	    	          {name:"Bagatelle"},
	    	          {name:"Bassignac"},
	    	          {name:"Bassignac"},
	    	          {name:"Beauséjour"},
	    	          {name:"Bocage"},
	    	          {name:"Bonneville"},
	    	          {name:"Bourg"},
	    	          {name:"Brevette"},
	    	          {name:"Brin d'Amour"},
	    	          {name:"Canal"},
	    	          {name:"Centre ville"},
	    	          {name:"Cosmy"},
	    	          {name:"Croix Guy"},
	    	          {name:"Degras"},
	    	          {name:"Descossieres"},
	    	          {name:"Desforts"},
	    	          {name:"Desmarinieres"},
	    	          {name:"Dijon"},
	    	          {name:"Doudou"},
	    	          {name:"Dufferret"},
	    	          {name:"Epinette"},
	    	          {name:"Ferret"},
	    	          {name:"Fond Bazile"},
	    	          {name:"Fonds Galion"},
	    	          {name:"Galion"},
	    	          {name:"Galion"},
	    	          {name:"Gergault"},
	    	          {name:"la Breche"},
	    	          {name:"la Camille"},
	    	          {name:"la Colline"},
	    	          {name:"la Crique"},
	    	          {name:"la Flotille"},
	    	          {name:"la Moise"},
	    	          {name:"les Dominants"},
	    	          {name:"Les Hauts"},
	    	          {name:"L'Autre Bord"},
	    	          {name:"l'autre bord"},
	    	          {name:"Malgre Tout"},
	    	          {name:"Maximin"},
	    	          {name:"Merveilleuse"},
	    	          {name:"Morne Figue"},
	    	          {name:"Morne Poirier"},
	    	          {name:"Petit Galion"},
	    	          {name:"Petite Rivière Salee"},
	    	          {name:"Plaisable"},
	    	          {name:"Poirier"},
	    	          {name:"Raisinier"},
	    	          {name:"Ressource"},
	    	          {name:"Tartane"},
	    	          {name:"tracée"},
	    	          {name:"Tracee Bonnin"},
	    	          {name:"Val Beausejour"},
	    	          {name:"Autre"},
        ] },
        { name: 'Le Carbet', quartiers: [
                    {name:"Anse Latouche"},
                    {name:"Bel Event"},
                    {name:"belfond"},
                    {name:"Bourg"},
                    {name:"Bout Bois"},
                    {name:"Centre ville"},
                    {name:"Dariste"},
                    {name:"Duvallon"},
                    {name:"fond bourlet"},
                    {name:"Four"},
                    {name:"Godinot"},
                    {name:"Gros Coulirous"},
                    {name:"la Berlin"},
                    {name:"la Cafeiere"},
                    {name:"Lajus 1"},
                    {name:"Lajus 2"},
                    {name:"Lajus 3"},
                    {name:"le Coin"},
                    {name:"le Fromager"},
                    {name:"le Trou"},
                    {name:"Longvillier"},
                    {name:"Morne Aux Boeufs"},
                    {name:"Morne Gabillon"},
                    {name:"Petite Rivire"},
                    {name:"Autre"},
  ] },
        { name: 'Le Diamant', quartiers: [
	    	          {name:"Ancinel"},
	    	          {name:"Anse Caffard"},
	    	          {name:"Artisanal de Taupiniere"},
	    	          {name:"Bitaille"},
	    	          {name:"Bonne Terre"},
	    	          {name:"Bourg"},
	    	          {name:"Carole"},
	    	          {name:"Centre ville"},
	    	          {name:"Chalopin"},
	    	          {name:"Dizac"},
	    	          {name:"Fond Camille"},
	    	          {name:"Fond Manoel"},
	    	          {name:"Fond Placide"},
	    	          {name:"Haut Morne"},
	    	          {name:"Jacqua"},
	    	          {name:"Jeanville"},
	    	          {name:"Joubadiere"},
	    	          {name:"la Cherry"},
	    	          {name:"la Melise"},
	    	          {name:"la Pointe"},
	    	          {name:"le Gaoule"},
	    	          {name:"Longuet"},
	    	          {name:"Mare Poirier"},
	    	          {name:"Morne Blanc"},
	    	          {name:"Morne Constant"},
	    	          {name:"Morne la Croix"},
	    	          {name:"Morne Pavillon"},
	    	          {name:"O Mullane"},
	    	          {name:"Petit Lezard"},
	    	          {name:"Quamalon"},
	    	          {name:"Ravine Gens Bois"},
	    	          {name:"Tamarin"},
	    	          {name:"Thoraille"},
	    	    {name:"Autre"},

        ] },
        { name: 'Le Francois', quartiers: [
	    	          {name:"2 Courants"},
	    	          {name:"Beauregard"},
	    	          {name:"Belle Ame"},
	    	          {name:"Bellegarde"},
	    	          {name:"Bois Soldat"},
	    	          {name:"Bonny"},
	    	          {name:"Bourg"},
	    	          {name:"Canal"},
	    	          {name:"Cap Est"},
	    	          {name:"Centre ville"},
	    	          {name:"Chapelle Villarson"},
	    	          {name:"Chopotte"},
	    	          {name:"Chopotte 1"},
	    	          {name:"Chopotte 2"},
	    	          {name:"Chopotte 3"},
	    	          {name:"Cotonnerie"},
	    	          {name:"Croix Pelage"},
	    	          {name:"Desroses"},
	    	          {name:"Dostaly"},
	    	          {name:"Dupuis"},
	    	          {name:"Fregate"},
	    	          {name:"Gabourin"},
	    	          {name:"Grand Fond"},
	    	          {name:"Hauteur Bellevue"},
	    	          {name:"la Francisque"},
	    	          {name:"la Haut"},
	    	          {name:"la Manzo"},
	    	          {name:"Magdelonnette"},
	    	          {name:"Mena"},
	    	          {name:"Morne acajou"},
	    	          {name:"Morne Courbaril"},
	    	          {name:"Morne Gamelle"},
	    	          {name:"Morne la Croix"},
	    	          {name:"Morne l'Estomac"},
	    	          {name:"Morne Pavillon"},
	    	          {name:"Morne Pitault"},
	    	          {name:"Otier"},
	    	          {name:"Perriolat 1"},
	    	          {name:"Perriolat 2"},
	    	          {name:"Perriolat 3"},
	    	          {name:"Petite France"},
	    	          {name:"pointe coucher"},
	    	          {name:"Pointe Courchet Nord"},
	    	          {name:"Pointe Thalemont"},
	    	          {name:"Presqu Ile"},
	    	          {name:"Rivire Bambou"},
	    	          {name:"Saint Laurent"},
	    	          {name:"Saint Laurent Bicetre"},
	    	          {name:"Saint Roch"},
	    	          {name:"Trianon"},
	    	          {name:"Vapeur"},
	    	    {name:"Autre"},

        ] },
        { name: 'Le Lamentin', quartiers: [
	    	          {name:"Acajou"},
	    	          {name:"Acajou Est"},
	    	          {name:"Acajou Nord"},
	    	          {name:"Acajou Ouest"},
	    	          {name:"Acajou Sud"},
	    	          {name:"Autoroute Césaire"},
	    	          {name:"Bas 2 Terres"},
	    	          {name:"Bas mission"},
	    	          {name:"Basse Gondeau"},
	    	          {name:"Bel Air"},
	    	          {name:"Bélème"},
	    	          {name:"Belfort"},
	    	          {name:"Belle Isle"},
	    	          {name:"Bellonie"},
	    	          {name:"Bochette"},
	    	          {name:"bois d'inde"},
	    	          {name:"Bois Neuf"},
	    	          {name:"bois quarré"},
	    	          {name:"bois rouge"},
	    	          {name:"Bourg"},
	    	          {name:"bourg"},
	    	          {name:"Brachet"},
	    	          {name:"Briere L'Isle"},
	    	          {name:"Calebassier"},
	    	          {name:"californie"},
	    	          {name:"Canal"},
	    	          {name:"Carrere"},
	    	          {name:"Centre ville"},
	    	          {name:"Chambord"},
	    	          {name:"croix rivail"},
	    	          {name:"Daubert"},
	    	          {name:"Durocher"},
	    	          {name:"Duschene 2"},
	    	          {name:"Duschene1"},
	    	          {name:"Floraindre"},
	    	          {name:"Fond bellemare"},
	    	          {name:"Fond coitron"},
	    	          {name:"Haute Gondeau"},
	    	          {name:"Hotel des plaisirs"},
	    	          {name:"jeanne d'arc"},
	    	          {name:"La ressource"},
	    	          {name:"La trompeuse"},
	    	          {name:"lareinty"},
	    	          {name:"long pré"},
	    	          {name:"Mahault"},
	    	          {name:"Mangot vulcin"},
	    	          {name:"Manzelle"},
	    	          {name:"Mont Vert"},
	    	          {name:"Monteol"},
	    	          {name:"morne carette"},
	    	          {name:"morne roches"},
	    	          {name:"Morne Serpent"},
	    	          {name:"Otier"},
	    	          {name:"Palmiste"},
	    	          {name:"Patit bambou"},
	    	          {name:"pays mélés"},
	    	          {name:"Pelletier"},
	    	          {name:"petit manoir"},
	    	          {name:"Petit morne"},
	    	          {name:"petit paradis"},
	    	          {name:"Petite riviere"},
	    	          {name:"Place d'armes"},
	    	          {name:"Plaisance"},
	    	          {name:"Pointe Jean Claude"},
	    	          {name:"Rives chancel"},
	    	          {name:"Riviere calecon"},
	    	          {name:"roche carré"},
	    	          {name:"Sarrault"},
	    	          {name:"Savane dede"},
	    	          {name:"Soudon"},
	    	          {name:"Trenelle"},
	    	          {name:"Union"},
	    	          {name:"Vert pré"},
	    	          {name:"vieux pont"},
	    	    {name:"Autre"},

        ] },
        { name: 'Le Lorrain', quartiers: [
	    	          {name:"Assier"},
	    	          {name:"Bas Ceron"},
	    	          {name:"Bn Repos"},
	    	          {name:"Bourg"},
	    	          {name:"Carabin"},
	    	          {name:"Carabin Bas"},
	    	          {name:"Centre ville"},
	    	          {name:"Crochemort"},
	    	          {name:"Etoile"},
	    	          {name:"Fonds Brule"},
	    	          {name:"Fonds Cany"},
	    	          {name:"Fonds Gens Libres"},
	    	          {name:"Fonds Grand Anse"},
	    	          {name:"Fonds Labour"},
	    	          {name:"Grosse Roche"},
	    	          {name:"Guerin"},
	    	          {name:"Macedoine"},
	    	          {name:"Maxime"},
	    	          {name:"Moreau"},
	    	          {name:"Morne Capot"},
	    	          {name:"Morne Ceron"},
	    	          {name:"Morne Ceron 1"},
	    	          {name:"Morne Ceron 2"},
	    	          {name:"Morne Savon"},
	    	          {name:"Pavillon"},
	    	          {name:"Redoute"},
	    	          {name:"Rivire Claire"},
	    	          {name:"Seguineau"},
	    	          {name:"Sous Bois"},
	    	          {name:"vallon"},
	    	          {name:"Vive"},
	    	    {name:"Autre"},

        ] },
        { name: 'Le Marigot', quartiers: [
	    	          {name:"Baignoire"},
	    	          {name:"Bourg"},
	    	          {name:"Centre ville"},
	    	          {name:"Charpentier"},
	    	          {name:"dominante"},
	    	          {name:"Dorival"},
	    	          {name:"Garane"},
	    	    {name:"Autre"},

        ] },
        { name: 'Le Marin', quartiers: [
	    	          {name:"Bourg"},
	    	          {name:"Cap beauchne"},
	    	          {name:"Centre ville"},
	    	          {name:"La agns"},
	    	          {name:"La berry"},
	    	          {name:"La Sulpice"},
	    	          {name:"morne gommier"},
	    	    {name:"Autre"},

        ] },
        { name: 'Le Morne Rouge', quartiers: [
	    	          {name:"Abdelkader"},
	    	          {name:"Balisier"},
	    	          {name:"Bourg"},
	    	          {name:"Centre ville"},
	    	          {name:"Chamonix"},
	    	          {name:"Champflore"},
	    	          {name:"des Grosses Roches"},
	    	          {name:"du Val Joli"},
	    	          {name:"fond marie reine"},
	    	          {name:"Fond Rose"},
	    	          {name:"Mespont"},
	    	          {name:"Proprete"},
	    	          {name:"Savane Petit"},
	    	          {name:"Zobeide"},
	    	    {name:"Autre"},

        ] },
        { name: 'Le Morne Vert', quartiers: [
	    	          {name:"Beauvalon"},
	    	          {name:"Bel Event"},
	    	          {name:"Bel Event 2"},
	    	          {name:"Bernadette"},
	    	          {name:"Bois Lezard"},
	    	          {name:"Bourg"},
	    	          {name:"Bout Barriere"},
	    	          {name:"Canton Suisse"},
	    	          {name:"Caplet"},
	    	          {name:"Centre Ville"},
	    	          {name:"Chateau"},
	    	          {name:"Fonds d'Or"},
	    	          {name:"Jean"},
	    	          {name:"Jolimont"},
	    	          {name:"la Croix"},
	    	          {name:"la Vigie"},
	    	          {name:"Mont Joly"},
	    	          {name:"Petite Rivière"},
	    	          {name:"Rivière Coco"},
	    	          {name:"Saint Maurice"},
	    	          {name:"Urion"},
	    	          {name:"Vaudrin"},
	    	    {name:"Autre"},

        ] },
        { name: 'Le Prêcheur', quartiers: [
	    	          {name:"Anse Belleville"},
	    	          {name:"Anse Ceron"},
	    	          {name:"Anse Couleuvre"},
	    	          {name:"Batiment Chelonia"},
	    	          {name:"Boisville"},
	    	          {name:"Bourg"},
	    	          {name:"Bourg"},
	    	          {name:"Calle des Marches"},
	    	          {name:"Centre Ville"},
	    	          {name:"Corido Man Coya"},
	    	          {name:"Corido Mayotte"},
	    	          {name:"Espace Samboura"},
	    	          {name:"Four A Chaux"},
	    	          {name:"Le Plan d'Eau"},
	    	          {name:"Les Abymes"},
	    	          {name:"Pointe Lamarre"},
	    	          {name:"Wet Bassignac"},
	    	          {name:"Wet Becune"},
	    	          {name:"Wet Dorade"},
	    	          {name:"Wet la Batterie"},
	    	          {name:"Wet Melon"},
	    	          {name:"Wet Momone"},
	    	          {name:"Wet Pory Papi"},
	    	          {name:"Wet Rele"},
	    	          {name:"Wet Sandopi"},
	    	          {name:"Wet Vare"},
	    	          {name:"Wet Zofi"},
	    	    {name:"Autre"},

        ] },
        { name: 'Le Robert', quartiers: [
	    	          {name:"Augrain"},
	    	          {name:"Augrain Nord"},
	    	          {name:"Augrain Sud"},
	    	          {name:"Bellay"},
	    	          {name:"Berthou"},
	    	          {name:"Bois Desir"},
	    	          {name:"Bois du parc"},
	    	          {name:"Bois Neuf"},
	    	          {name:"Bois Potheau"},
	    	          {name:"Bois Zombi"},
	    	          {name:"Bonneau"},
	    	          {name:"Bourg"},
	    	          {name:"Boutaud"},
	    	          {name:"Bresson"},
	    	          {name:"Brice"},
	    	          {name:"Cafe"},
	    	          {name:"Cannelle"},
	    	          {name:"Centre ville"},
	    	          {name:"Chamfleury"},
	    	          {name:"Chere Epice"},
	    	          {name:"Cite Lacroix"},
	    	          {name:"Coulisse Mignot"},
	    	          {name:"Coulisse Mont Vert"},
	    	          {name:"Duchene"},
	    	          {name:"ermitage"},
	    	          {name:"Fond Brule"},
	    	          {name:"Fond Cacao"},
	    	          {name:"Fond Duchene"},
	    	          {name:"Fond d'Or"},
	    	          {name:"Galette"},
	    	          {name:"Gaschette"},
	    	          {name:"Hauteur Fond Nicolas"},
	    	          {name:"Hauteur Four A Chaux"},
	    	          {name:"Hauteur Pontalery"},
	    	          {name:"La birot"},
	    	          {name:"la Cadet"},
	    	          {name:"la Charles"},
	    	          {name:"la Digue"},
	    	          {name:"la Dirozo"},
	    	          {name:"la Moise"},
	    	          {name:"Lacroix"},
	    	          {name:"Lazaret"},
	    	          {name:"Lecomte"},
	    	          {name:"Lestrade"},
	    	          {name:"l'Heureux"},
	    	          {name:"Mansarde catalogne"},
	    	          {name:"Mansarde rancée"},
	    	          {name:"Marlet"},
	    	          {name:"Mena"},
	    	          {name:"Monnerot"},
	    	          {name:"Mont Vert"},
	    	          {name:"Morne Galbas"},
	    	          {name:"Moulin A Vent"},
	    	          {name:"Pointe Fort"},
	    	          {name:"Pointe Hyacinthe"},
	    	          {name:"Pointe Jean Claude"},
	    	          {name:"Pointe la Rose"},
	    	          {name:"Pointe Lynch"},
	    	          {name:"Pointe Rouge"},
	    	          {name:"Pointe Royale"},
	    	          {name:"pointe savane"},
	    	          {name:"Pontalery"},
	    	          {name:"Providence"},
	    	          {name:"Raisin"},
	    	          {name:"Reunion"},
	    	          {name:"Reynoird"},
	    	          {name:"Sabine"},
	    	          {name:"Sable Blanc"},
	    	          {name:"Saint Christophe"},
	    	          {name:"Trou Terre"},
	    	          {name:"Vert pré"},
	    	          {name:"Voltaire"},
	    	          {name:"Yoyoye"},
	    	          {name:"Zabeth"},
	    	    {name:"Autre"},

        ] },
        { name: 'Le Vauclin', quartiers: [
	    	          {name:"Baie des Mulets"},
	    	          {name:"Beaujolais"},
	    	          {name:"Belle Etoile"},
	    	          {name:"Bellevue"},
	    	          {name:"Benguette"},
	    	          {name:"Boe"},
	    	          {name:"Bourg"},
	    	          {name:"Cadette"},
	    	          {name:"Cambeilh"},
	    	          {name:"Carrire"},
	    	          {name:"Centre ville"},
	    	          {name:"Chamfleury"},
	    	          {name:"Chateau d'Eau"},
	    	          {name:"Coq"},
	    	          {name:"Coulee d'Or"},
	    	          {name:"Dessaint"},
	    	          {name:"Ducassous"},
	    	          {name:"Dunoyer"},
	    	          {name:"Ensfelder"},
	    	          {name:"Escarvaille"},
	    	          {name:"Fond Zamy"},
	    	          {name:"Fonds Mulatre"},
	    	          {name:"Four"},
	    	          {name:"Goujon"},
	    	          {name:"Grand Boucan"},
	    	          {name:"haut de maniba"},
	    	          {name:"Humbert"},
	    	          {name:"la Broue"},
	    	          {name:"la Ferme"},
	    	          {name:"la Montagn"},
	    	          {name:"l'Union"},
	    	          {name:"Macabou"},
	    	          {name:"Malveaux"},
	    	          {name:"Mont Vert"},
	    	          {name:"Morne Carrire"},
	    	          {name:"Morne la Croix"},
	    	          {name:"Morne Raquette"},
	    	          {name:"Neveu"},
	    	          {name:"Paquemar"},
	    	          {name:"Petit Campeche"},
	    	          {name:"Petit Perou"},
	    	          {name:"Petite Grenade"},
	    	          {name:"Petite Ravine"},
	    	          {name:"Placide"},
	    	          {name:"Pointe Athanase"},
	    	          {name:"Pointe Chaudiere"},
	    	          {name:"Pointe Faula"},
	    	          {name:"Puyferrat"},
	    	          {name:"ravine plate"},
	    	          {name:"Sans Souci"},
	    	          {name:"Sigy"},
	    	    {name:"Autre"},

        ] },
        { name: "Les Anses d'Arlet", quartiers: [
	    	          {name:"Anse Chaudière"},
	    	          {name:"Anse d'arlet"},
	    	          {name:"Anse Dufour"},
	    	          {name:"Anse Noire"},
	    	          {name:"Batterie"},
	    	          {name:"Bourg"},
	    	          {name:"Casin"},
	    	          {name:"Cassiere"},
	    	          {name:"Cocoyers"},
	    	          {name:"Coin Bananes"},
	    	          {name:"Coin des Peres"},
	    	          {name:"Flandrin"},
	    	          {name:"Fond Fleury"},
	    	          {name:"Gallochat"},
	    	          {name:"Grande Anse"},
	    	          {name:"l'Etang"},
	    	          {name:"La Plaine"},
	    	          {name:"Maleau"},
	    	          {name:"Mapou"},
	    	          {name:"Medelice"},
	    	          {name:"Morne Bigot"},
	    	          {name:"Morne Gentil"},
	    	          {name:"Morne Jacqueline"},
	    	          {name:"Palmiste"},
	    	          {name:"Petit Anse"},
	    	          {name:"Séjourner"},
	    	          {name:"Zaire"},
	    	    {name:"Autre"},

        ] },
        { name: 'Les Trois Ilets', quartiers: [
	    	          {name:"Anse a l'ane"},
	    	          {name:"Anse Mitan"},
	    	          {name:"Beaufond"},
	    	          {name:"Bigotte"},
	    	          {name:"Bourg"},
	    	          {name:"Centre ville"},
	    	          {name:"Charles Pieds"},
	    	          {name:"ChEteau Gaillard"},
	    	          {name:"Concorde"},
	    	          {name:"Desloges"},
	    	          {name:"Fond Fleury"},
	    	          {name:"Glacy"},
	    	          {name:"la Capoul"},
	    	          {name:"la Clouette"},
	    	          {name:"la Debat"},
	    	          {name:"la Pagerie"},
	    	          {name:"la Source"},
	    	          {name:"Magasin Zeline"},
	    	          {name:"Morne Bigot"},
	    	          {name:"Morne Vent"},
	    	          {name:"Papias"},
	    	          {name:"Phaeton"},
	    	          {name:"Pointe du bout"},
	    	          {name:"Pointe Etienne"},
	    	          {name:"Pointe Vatable"},
	    	          {name:"Poterie"},
	    	          {name:"Radar"},
	    	          {name:"Rateau"},
	    	          {name:"Sarcelle"},
	    	          {name:"Thomas"},
	    	          {name:"Vatable"},
	    	          {name:"Wallon"},
	    	    {name:"Autre"},

        ] },
        { name: 'Macouba', quartiers: [
	    	          {name:"Bellevue"},
	    	          {name:"Bourg"},
	    	          {name:"Centre Ville"},
	    	          {name:"Cheneaux"},
	    	          {name:"Guerin"},
	    	          {name:"Perpigna"},
	    	          {name:"Potiche"},
	    	          {name:"Terre Patate"},
	    	    {name:"Autre"},

        ] },
        { name: 'Rivière Pilote', quartiers: [
	    	          {name:"Abondance"},
	    	          {name:"Anse Figuier"},
	    	          {name:"Bas Mangots"},
	    	          {name:"Baudelle"},
	    	          {name:"Beauregard Cafeiere"},
	    	          {name:"Beauregard Sucriere"},
	    	          {name:"Bellay"},
	    	          {name:"Bonne Terre"},
	    	          {name:"Borel"},
	    	          {name:"Bourg"},
	    	          {name:"Canari Casse"},
	    	          {name:"Centre ville"},
	    	          {name:"Chevalier"},
	    	          {name:"Cocoyers"},
	    	          {name:"Coulanges"},
	    	          {name:"Croix Godet"},
	    	          {name:"Derriere Morne"},
	    	          {name:"Desfarges"},
	    	          {name:"Desruisseaux"},
	    	          {name:"En Bellay"},
	    	          {name:"En Brie"},
	    	          {name:"Escarvaille"},
	    	          {name:"fond bourlet"},
	    	          {name:"Fond Mulatre"},
	    	          {name:"Gervais"},
	    	          {name:"Josseaud"},
	    	          {name:"la Beaume"},
	    	          {name:"la Debat"},
	    	          {name:"la Faveur"},
	    	          {name:"La Regale"},
	    	          {name:"la Renee"},
	    	          {name:"Lourdes"},
	    	          {name:"Lowinsky"},
	    	          {name:"l'Escouet"},
	    	          {name:"Mare Capron"},
	    	          {name:"Marianne"},
	    	          {name:"Marie Noire"},
	    	          {name:"Massonville"},
	    	          {name:"Mathurin"},
	    	          {name:"Mauny"},
	    	          {name:"Mauny Concorde"},
	    	          {name:"Mayol"},
	    	          {name:"Montplaisir"},
	    	          {name:"Morency"},
	    	          {name:"Morne Abricot"},
	    	          {name:"Morne Escarpe"},
	    	          {name:"Morne Honore"},
	    	          {name:"Morne Pavillon"},
	    	          {name:"Morne Roches"},
	    	          {name:"Morne Vent"},
	    	          {name:"Pain Bis"},
	    	          {name:"Perrine"},
	    	          {name:"Petit Coton"},
	    	          {name:"Plat Peyi"},
	    	          {name:"Poirier"},
	    	          {name:"Pomare"},
	    	          {name:"Pont Madeleine"},
	    	          {name:"Prefontaine"},
	    	          {name:"Ravine Acajou"},
	    	          {name:"Ravine Braie"},
	    	          {name:"Regale"},
	    	          {name:"Regale Renee"},
	    	          {name:"Rivage"},
	    	          {name:"Rodalie"},
	    	          {name:"Rollin"},
	    	          {name:"Saint Pont"},
	    	          {name:"Saint Vincent"},
	    	          {name:"Vieille Citerne"},
	    	          {name:"Vieilles Terres"},
	    	          {name:"Vignette"},
	    	    {name:"Autre"},

        ] },
        { name: 'Rivière Salée', quartiers: [
	    	          {name:"Abondance"},
	    	          {name:"Anse Figuier"},
	    	          {name:"Bas Mangots"},
	    	          {name:"Baudelle"},
	    	          {name:"Beauregard Cafeiere"},
	    	          {name:"Beauregard Sucriere"},
	    	          {name:"Bellay"},
	    	          {name:"Bonne Terre"},
	    	          {name:"Borel"},
	    	          {name:"Bourg"},
	    	          {name:"Canari Casse"},
	    	          {name:"Centre ville"},
	    	          {name:"Chevalier"},
	    	          {name:"Cocoyers"},
	    	          {name:"Coulanges"},
	    	          {name:"Croix Godet"},
	    	          {name:"Derriere Morne"},
	    	          {name:"Desfarges"},
	    	          {name:"Desruisseaux"},
	    	          {name:"En Bellay"},
	    	          {name:"En Brie"},
	    	          {name:"Escarvaille"},
	    	          {name:"fond bourlet"},
	    	          {name:"Fond Mulatre"},
	    	          {name:"Gervais"},
	    	          {name:"Josseaud"},
	    	          {name:"la Beaume"},
	    	          {name:"la Debat"},
	    	          {name:"la Faveur"},
	    	          {name:"La Regale"},
	    	          {name:"la Renee"},
	    	          {name:"Lourdes"},
	    	          {name:"Lowinsky"},
	    	          {name:"l'Escouet"},
	    	          {name:"Mare Capron"},
	    	          {name:"Marianne"},
	    	          {name:"Marie Noire"},
	    	          {name:"Massonville"},
	    	          {name:"Mathurin"},
	    	          {name:"Mauny"},
	    	          {name:"Mauny Concorde"},
	    	          {name:"Mayol"},
	    	          {name:"Montplaisir"},
	    	          {name:"Morency"},
	    	          {name:"Morne Abricot"},
	    	          {name:"Morne Escarpe"},
	    	          {name:"Morne Honore"},
	    	          {name:"Morne Pavillon"},
	    	          {name:"Morne Roches"},
	    	          {name:"Morne Vent"},
	    	          {name:"Pain Bis"},
	    	          {name:"Perrine"},
	    	          {name:"Petit Coton"},
	    	          {name:"Plat Peyi"},
	    	          {name:"Poirier"},
	    	          {name:"Pomare"},
	    	          {name:"Pont Madeleine"},
	    	          {name:"Prefontaine"},
	    	          {name:"Ravine Acajou"},
	    	          {name:"Ravine Braie"},
	    	          {name:"Regale"},
	    	          {name:"Regale Renee"},
	    	          {name:"Rivage"},
	    	          {name:"Rodalie"},
	    	          {name:"Rollin"},
	    	          {name:"Saint Pont"},
	    	          {name:"Saint Vincent"},
	    	          {name:"Vieille Citerne"},
	    	          {name:"Vieilles Terres"},
	    	          {name:"Vignette"},
	    	    {name:"Autre"},

        ] },
        { name: 'Saint Esprit', quartiers: [
	    	          {name:"7 Croisees"},
	    	          {name:"Baldara"},
	    	          {name:"Bellay"},
	    	          {name:"Bois Blanc"},
	    	          {name:"Bontemps la Cour"},
	    	          {name:"Bourg"},
	    	          {name:"Centre ville"},
	    	          {name:"David"},
	    	          {name:"Dieuzede"},
	    	          {name:"Duchatel"},
	    	          {name:"Firmin"},
	    	          {name:"Fonds Coulisses"},
	    	          {name:"Fontenay"},
	    	          {name:"Four A Chaux"},
	    	          {name:"Gd Bassin Grosse Roche"},
	    	          {name:"Gogo"},
	    	          {name:"Grand Bassin"},
	    	          {name:"Grand Case"},
	    	          {name:"la Capoul"},
	    	          {name:"La Carreau"},
	    	          {name:"la Ferme"},
	    	          {name:"la LE ROBERT"},
	    	          {name:"la Nau"},
	    	          {name:"la Suin"},
	    	          {name:"Laboissiere"},
	    	          {name:"Lannuquette"},
	    	          {name:"le Coin"},
	    	          {name:"l'Avenir"},
	    	          {name:"Mathilde"},
	    	          {name:"Morne Babet"},
	    	          {name:"Morne Degras"},
	    	          {name:"Morne la Croix"},
	    	          {name:"Morne Lavaleur"},
	    	          {name:"Morne Vent"},
	    	          {name:"Nicolas"},
	    	          {name:"Palmene"},
	    	          {name:"Peters Maillet"},
	    	          {name:"Petit Paradis"},
	    	          {name:"Placide"},
	    	          {name:"Pointe Royale"},
	    	          {name:"Presqu Ile"},
	    	          {name:"Regale Beauplan"},
	    	          {name:"Regale Fond la Pierre"},
	    	          {name:"Regale Modere"},
	    	          {name:"Rivire Moquette"},
	    	          {name:"Roussane"},
	    	          {name:"Saint Ange"},
	    	          {name:"Solitude"},
	    	          {name:"Suffin"},
	    	          {name:"Terres Gueydon"},
	    	          {name:"Thibault"},
	    	          {name:"Valatte"},
	    	          {name:"Vieille Citerne"},
	    	    {name:"Autre"},

        ] },
        { name: 'Saint Joseph', quartiers: [
	    	          {name:"Belle Etoile"},
	    	          {name:"Bois du parc"},
	    	          {name:"Bois Neuf"},
	    	          {name:"Bourg"},
	    	          {name:"Centre ville"},
	    	          {name:"Chapelle"},
	    	          {name:"Choco"},
	    	          {name:"Choisy"},
	    	          {name:"croix z'abricot"},
	    	          {name:"durant"},
	    	          {name:"fond cacao"},
	    	          {name:"Fonds Epingles"},
	    	          {name:"Gondeau"},
	    	          {name:"goureau"},
	    	          {name:"Hermitage lacroix"},
	    	          {name:"Horizon 2000"},
	    	          {name:"Hotel des plaisirs"},
	    	          {name:"long bois"},
	    	          {name:"Morne des Olives"},
	    	          {name:"Petit berry"},
	    	          {name:"Presqu Ile"},
	    	          {name:"rabuchon"},
	    	          {name:"riviere blanche"},
	    	          {name:"rosiere"},
	    	          {name:"Rousseau"},
	    	          {name:"salubre"},
	    	          {name:"seaille"},
	    	          {name:"Valee heureuse"},
	    	    {name:"Autre"},

        ] },
        { name: 'Saint Pierre', quartiers: [
	    	          {name:"Bourg"},
	    	          {name:"Centre ville"},
	    	          {name:"cocotte"},
	    	          {name:"des 3 Ponts"},
	    	          {name:"Habitation Plaisance"},
	    	          {name:"Perinelle"},
	    	          {name:"Saint James"},
	    	          {name:"Savane du For"},
	    	    {name:"Autre"},

        ] },
        { name: 'Sainte Anne', quartiers: [
	    	          {name:"Anse Michel"},
	    	          {name:"Bareto"},
	    	          {name:"Barriere la Croix"},
	    	          {name:"Belle Languette"},
	    	          {name:"Belvedere"},
	    	          {name:"Bourg"},
	    	          {name:"Cap Cabaret"},
	    	          {name:"Cap Chevalier"},
	    	          {name:"Cap Ferre"},
	    	          {name:"Cap Macre"},
	    	          {name:"Cassiere"},
	    	          {name:"Centre ville"},
	    	          {name:"Creve Cìur"},
	    	          {name:"Debarcadere"},
	    	          {name:"Derriere Morne"},
	    	          {name:"Fond Repos"},
	    	          {name:"Gautonne"},
	    	          {name:"la Casse"},
	    	          {name:"les Anglais"},
	    	          {name:"les Hauts de Beauregard"},
	    	          {name:"les Hauts Etages"},
	    	          {name:"Madet"},
	    	          {name:"Manon"},
	    	          {name:"Panorama"},
	    	          {name:"Pointe Chaudiere"},
	    	          {name:"Pointe Marin"},
	    	          {name:"Rabat Joie"},
	    	    {name:"Autre"},

        ] },
        { name: 'Sainte Luce', quartiers: [
	    	          {name:"Anse Mabouya"},
	    	          {name:"Bastopol"},
	    	          {name:"Beaulieu"},
	    	          {name:"Bellay"},
	    	          {name:"Bellevue Ladour"},
	    	          {name:"Belvedere"},
	    	          {name:"Beola"},
	    	          {name:"Bernard"},
	    	          {name:"Blanchard"},
	    	          {name:"Bourg"},
	    	          {name:"Centre ville"},
	    	          {name:"Ceron"},
	    	          {name:"Corps de Garde"},
	    	          {name:"Delivry"},
	    	          {name:"delivry"},
	    	          {name:"Desert"},
	    	          {name:"Deville"},
	    	          {name:"Epinay"},
	    	          {name:"Grand Figue"},
	    	          {name:"Gros Raisins"},
	    	          {name:"Jacques"},
	    	          {name:"la Croix"},
	    	          {name:"la Disjonslee"},
	    	          {name:"Lavison"},
	    	          {name:"les Coteaux"},
	    	          {name:"l'Epinay"},
	    	          {name:"mondesir"},
	    	          {name:"Monesie"},
	    	          {name:"Mont Caraibe"},
	    	          {name:"Montravail"},
	    	          {name:"Morne des Peres"},
	    	          {name:"Oblot"},
	    	          {name:"Petit Fond"},
	    	          {name:"Trois Rivires"},
	    	          {name:"Trou au Diable"},
	    	          {name:"Vezieres"},
	    	          {name:"Volcart"},
	    	          {name:"Voleau"},
	    	    {name:"Autre"},

        ] },
        { name: 'Sainte Marie', quartiers: [
	    	          {name:"Anso"},
	    	          {name:"Bagou"},
	    	          {name:"Bassin Noir"},
	    	          {name:"Belvedere"},
	    	          {name:"Bezaudin"},
	    	          {name:"Bois Jade"},
	    	          {name:"Bon Air"},
	    	          {name:"Bonneau"},
	    	          {name:"Bourg"},
	    	          {name:"Cadran"},
	    	          {name:"Centre ville"},
	    	          {name:"Chataigne France"},
	    	          {name:"Chertine"},
	    	          {name:"Citron"},
	    	          {name:"Clauzel"},
	    	          {name:"Debarcadere"},
	    	          {name:"Duchamp"},
	    	          {name:"Epineux"},
	    	          {name:"Eudorcait"},
	    	          {name:"eudorsaix"},
	    	          {name:"fourniol"},
	    	          {name:"la Bambouseraie"},
	    	          {name:"la Capoul"},
	    	          {name:"la Charmeuse"},
	    	          {name:"La Regale"},
	    	          {name:"Lagrosilliere"},
	    	          {name:"Lassalle"},
	    	          {name:"Lucon"},
	    	          {name:"Macroix"},
	    	          {name:"Maziere"},
	    	          {name:"Morne des esses"},
	    	          {name:"Morne Elie"},
	    	          {name:"Mornes A Roches"},
	    	          {name:"Mounzy"},
	    	          {name:"Perou"},
	    	          {name:"Plaisance"},
	    	          {name:"p_rou robin"},
	    	          {name:"Ransay"},
	    	          {name:"Reculee"},
	    	          {name:"Rivire Canaris"},
	    	          {name:"Rivire Romanet"},
	    	          {name:"Robin"},
	    	          {name:"Rodon"},
	    	          {name:"saint jacques"},
	    	          {name:"Saint Laurent"},
	    	          {name:"Spourtoune"},
	    	          {name:"St Aroman"},
	    	          {name:"Tenos"},
	    	          {name:"Trou Mangouste"},
	    	          {name:"villeneuve"},
	    	    {name:"Autre"},

        ] },
        { name: 'Schoelcher', quartiers: [
	    	          {name:"Anse collat"},
	    	          {name:"Anse Gourault"},
	    	          {name:"Anse Madame"},
	    	          {name:"Bassignac"},
	    	          {name:"Batelire"},
	    	          {name:"Batterie"},
	    	          {name:"Beauregard"},
	    	          {name:"Bourg"},
	    	          {name:"case navire"},
	    	          {name:"Centre ville"},
	    	          {name:"Cite st Georges"},
	    	          {name:"enclos"},
	    	          {name:"Fond bateliere"},
	    	          {name:"Fond bernier"},
	    	          {name:"Fonds Duclos"},
	    	          {name:"Fonds lahaye"},
	    	          {name:"Fonds Nigaud"},
	    	          {name:"Gros Raisins"},
	    	          {name:"les hauts de madiana"},
	    	          {name:"Madiana"},
	    	          {name:"Morne Pavillon"},
	    	          {name:"plateau fofo"},
	    	          {name:"pointe de jaham"},
	    	          {name:"ravine touza"},
	    	          {name:"saint georges"},
	    	          {name:"terreville"},
	    	    {name:"Autre"},
] },
      ],
    },
    {
      name: 'Guadeloupe',
      villes: [
        { name: 'Les Abymes', quartiers: [] },
        { name: 'Anse-Bertrand', quartiers: [] },
        { name: 'Baie-Mahault', quartiers: [] },
        { name: 'Baillif', quartiers: [] },
        { name: 'Basse-Terre', quartiers: [] },
        { name: 'Bouillante', quartiers: [] },
        { name: 'Capesterre-Belle-Eau', quartiers: [] },
        { name: 'Capesterre-de-Marie-Galante', quartiers: [] },
        { name: 'Deshaies', quartiers: [] },
        { name: 'La Désirade', quartiers: [] },
        { name: 'Le Gosier', quartiers: [] },
        { name: 'Gourbeyre', quartiers: [] },
        { name: 'Goyave', quartiers: [] },
        { name: 'Grand-Bourg', quartiers: [] },
        { name: 'Lamentin', quartiers: [] },
        { name: "Morne-à-l'Eau", quartiers: [] },
        { name: 'Le Moule', quartiers: [] },
        { name: 'Petit-Bourg', quartiers: [] },
        { name: 'Petit-Canal', quartiers: [] },
        { name: 'Pointe-à-Pitre', quartiers: [] },
        { name: 'Pointe-Noire', quartiers: [] },
        { name: 'Port-Louis', quartiers: [] },
        { name: 'Saint-Claude', quartiers: [] },
        { name: 'Saint-François', quartiers: [] },
        { name: 'Saint-Louis', quartiers: [] },
        { name: 'Sainte-Anne', quartiers: [] },
        { name: 'Sainte-Rose', quartiers: [] },
        { name: 'Terre-de-Bas', quartiers: [] },
        { name: 'Terre-de-Haut', quartiers: [] },
        { name: 'Trois-Rivières', quartiers: [] },
        { name: 'Vieux-Fort', quartiers: [] },
        { name: 'Vieux-Habitants', quartiers: [] },
      ],
    },
    {
      name: 'Guyane',
      villes: [
        { name: 'Apatou', quartiers: [] },
        { name: 'Awala-Yalimapo', quartiers: [] },
        { name: 'Camopi', quartiers: [] },
        { name: 'Cayenne', quartiers: [] },
        { name: 'Grand-Santi', quartiers: [] },
        { name: 'Iracoubo', quartiers: [] },
        { name: 'Kourou', quartiers: [] },
        { name: 'Macouria', quartiers: [] },
        { name: 'Mana', quartiers: [] },
        { name: 'Maripasoula', quartiers: [] },
        { name: 'Matoury', quartiers: [] },
        { name: 'Montsinéry-Tonnegrande', quartiers: [] },
        { name: 'Ouanary', quartiers: [] },
        { name: 'Papaïchton', quartiers: [] },
        { name: 'Régina', quartiers: [] },
        { name: 'Rémire-Montjoly', quartiers: [] },
        { name: 'Roura', quartiers: [] },
        { name: 'Saint-Élie', quartiers: [] },
        { name: "Saint-Georges-de-l'Oyapock", quartiers: [] },
        { name: 'Saint-Laurent-du-Maroni', quartiers: [] },
        { name: 'Saül', quartiers: [] },
        { name: 'Sinnamary', quartiers: [] },
      ],
    },
    {name:'Réunion',
  villes:[
     {name :"Les Avirons", quartiers:[]},
                            {name :"Bras-Panon", quartiers:[]},
                            {name :"Cilaos", quartiers:[]},
                            {name :"Entre-Deux", quartiers:[]},
                            {name :"L'Étang-Salé ", quartiers:[]},
                            {name :"Petite-Île", quartiers:[]},
                            {name :"La Plaine-des-Palmistes", quartiers:[]},
                            {name :"Le Port", quartiers:[]},
                            {name :"La Possession", quartiers:[]},
                            {name :"Saint-André", quartiers:[]},
                            {name :"Saint-Benoît", quartiers:[]},
                            {name :"Saint-Denis", quartiers:[]},
                            {name :"Sainte-Marie", quartiers:[]},
                            {name :"Sainte-Rose", quartiers:[]},
                            {name :"Sainte-Suzanne", quartiers:[]},
                            {name :"Saint-Joseph", quartiers:[]},
                            {name :"Saint-Leu", quartiers:[]},
                            {name :"Saint-Louis", quartiers:[]},
                            {name :"Saint-Paul", quartiers:[]},
                            {name :"Saint-Philippe", quartiers:[]},
                            {name :"Saint-Pierre", quartiers:[]},
                            {name :"Salazie", quartiers:[]},
                            {name :"Le Tampon", quartiers:[]},
                            {name :"Les Trois-Bassins", quartiers:[]},

  ]},
  {
    name:'France Hexagonale',
    villes:[]
  }
  ];
  villeList=[]
  quartierList=[];

  canNextStep: boolean = false;
  subscriptions: any = [];
  currentUser: user|any;
  modalCguVisible: boolean = false;
  modalRgpdVisible: boolean = false;
  cguAccepted;
  constructor(
    public inscriptionService: ForumInscriptionService,
    public authenticationService: AuthenticationService,
    private usersService: UsersService
  ) {
    this.subscriptions.push(
      this.authenticationService.currentUser.subscribe((x) => {
        this.currentUser = x;
        this.refreshForm();
      })
    );
  }

  ngOnDestroy() {
    _.each(this.subscriptions, (sub) => sub.unsubscribe());
  }

  ngOnInit(): void {
    this.refreshForm();
  }
  refreshForm() {
    if (this.currentUser)
      this.inscriptionService.form.user = {
        prenom: this.currentUser.prenom,
        nom: this.currentUser.nom,
        adresse: this.currentUser.adresse,
        adresseAlt: this.currentUser.adresseAlt,
        dateNaissance: this.currentUser.dateNaissance,
        ville: this.currentUser.ville,
        pays: this.currentUser.pays,
        quartier: this.currentUser.quartier,
        codePostal: this.currentUser.codePostal,
        email: this.currentUser.email,
        telephone: this.currentUser.telephone,
        csp: this.currentUser.csp,
      };

      this.refreshVilles();
      this.refreshQuartiers();
    if (this.inscriptionService.form.user.email)
      this.checkCanNextStep(null, true);

  }
  async checkCanNextStep(param, full?,callback?) {
    console.log(
      'checkCanNextStep',
      param,
      this.inscriptionService.form.user[param]
    );
    // nom
    let hasError;
    let formHasError = 0;
    if (full) param = 'nom';
    if (param == 'nom') {
      hasError = false;
      if (
        this.inscriptionService.form.user[param]?.length < 2 ||
        !this.inscriptionService.form.user[param]
      ) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Veuillez renseigner votre nom',
        };
      }
      if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    }

    // prenom
    if (full) param = 'prenom';
    if (param == 'prenom') {
      hasError = false;
      if (
        this.inscriptionService.form.user[param]?.length < 2 ||
        !this.inscriptionService.form.user[param]
      ) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Veuillez renseigner votre prénom',
        };
      }
      if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    }

    ///
    if (full) param = 'dateNaissance';
    if (param == 'dateNaissance') {
      hasError = false;
      if (!this.inscriptionService.form.user[param]) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Veuillez renseigner votre date de naissance',
        };
      }
      if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    }

    // if (full) param = 'adresse';
    // if (param == 'adresse') {
    //   hasError = false;
    //   if (
    //     this.inscriptionService.form.user[param]?.length < 10 ||
    //     !this.inscriptionService.form.user[param]
    //   ) {
    //     hasError = true;
    //     this.formCheck[param] = {
    //       hasError: true,
    //       message: 'Veuillez renseigner votre adresse',
    //     };
    //   }
    //   if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    // }

    if (full) param = 'ville';
    if (param == 'ville') {
      hasError = false;
      if (
        this.inscriptionService.form.user[param]?.length < 2 ||
        !this.inscriptionService.form.user[param]
      ) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Veuillez renseigner votre ville',
        };
      }
      if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    }
    if (full) param = 'pays';
    if (param == 'pays') {
      hasError = false;
      if (
        this.inscriptionService.form.user[param]?.length < 2 ||
        !this.inscriptionService.form.user[param]
      ) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Veuillez renseigner votre pays',
        };
      }
      if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    }
    if (full) param = 'quartier';
    if (param == 'quartier') {
      hasError = false;
      if (
        this.inscriptionService.form.user[param]?.length < 2 ||
        !this.inscriptionService.form.user[param]
      ) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Veuillez renseigner votre quartier',
        };
      }
      if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    }
    // if (full) param = 'codePostal';
    // if (param == 'codePostal') {
    //   hasError = false;
    //   if (
    //     this.inscriptionService.form.user[param]?.length < 2 ||
    //     !this.inscriptionService.form.user[param]
    //   ) {
    //     hasError = true;
    //     this.formCheck[param] = {
    //       hasError: true,
    //       message: 'Veuillez renseigner votre Code Postal',
    //     };
    //   }
    //   if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    // }
    if (full) param = 'email';
    if (param == 'email') {
      hasError = false;
      if (
        this.inscriptionService.form.user[param]?.length < 2 ||
        !this.inscriptionService.form.user[param]
      ) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Veuillez renseigner votre Email',
        };
      }

      if (!this.validateEmail(this.inscriptionService.form.user[param])) {
        hasError = true;
        this.formCheck[param] = { hasError: true, message: 'Email incorrect' };
      } else if (
        (this.currentUser &&
        this.inscriptionService.form.user[param] != this.currentUser.email) || !this.currentUser
      ) {
		  this.alreadyInscription = null;
        // verify user exist
        let exist = await this.authenticationService
          .verifyExist(this.inscriptionService.form.user[param])
          .toPromise()
          .then((res) => {
            // console.log('res', res);
            return res;
          });
        if (exist?.msg == 'already exist') {
			this.getInscriptionByEmail(this.inscriptionService.form.user[param])
          hasError = true;
          this.formCheck[param] = {
            hasError: true,
            message:
            //   'Cet email existe déjà, veuillez-vous connecter pour mettre à jour votre inscription',
			'Cet email existe déjà, si vous vous êtes déjà inscrit : contactez-nous via le chat pour mettre à jour votre inscription.'
          };
        }
      }
      if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    }
    if (full) param = 'telephone';
    if (param == 'telephone') {
      hasError = false;
      if (
        this.inscriptionService.form.user[param]?.length < 2 ||
        !this.inscriptionService.form.user[param]
      ) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Veuillez renseigner votre Telephone',
        };
      }
      if (!this.validatePhonenumber(this.inscriptionService.form.user[param])) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Telephone incorrect',
        };
      }
      if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    }
    if (full) param = 'csp';
    if (param == 'csp') {
      hasError = false;
      if (
        this.inscriptionService.form.user[param]?.length < 2 ||
        !this.inscriptionService.form.user[param]
      ) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Veuillez renseigner votre Catégorie Socioprofessionnelle',
        };
      }
      if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    }

    if (full) param = 'cguAccepted';
    if (param == 'cguAccepted') {
      hasError = false;
      console.log('this.cguAccepted', this.cguAccepted);
      if (!this.cguAccepted) {
        hasError = true;
        this.formCheck[param] = {
          hasError: true,
          message: 'Veuillez accepter les conditions générales',
        };
      }
      if (!hasError) this.formCheck[param] = { hasError: false, message: '' };
    }

    // console.log('formHasError',formHasError)
    // if(full){
    _.each(Object.keys(this.formCheck), (c) => {
      if (this.formCheck[c]?.hasError !== false) {
        formHasError++;
        console.log('c', c);
      }
    });
    if (!formHasError) this.canNextStep = true;
    else this.canNextStep = false;
    // }

    this.inscriptionService.saveFormSessionStorage();

    if(callback && this.canNextStep){
      callback();
    }
  }
  refreshVilles(clear?){
    if(clear)
    this.inscriptionService.form.user.ville = ""
    let territoire = _.find(this.territoireList,t=> t.name == this.inscriptionService.form.user.pays);
    this.villeList = territoire.villes;
    this.quartierList=[];
  }
  refreshQuartiers(clear?){
    if(clear)
    this.inscriptionService.form.user.quartier = ""
    let ville = _.find(this.villeList,v=> v.name == this.inscriptionService.form.user.ville);
    this.quartierList=ville.quartiers;
  }
  validatePhonenumber(inputtxt) {
    var phoneno = /^\d{10}$/;
    if (inputtxt.match(phoneno)) {
      return true;
    } else {
      return false;
    }
  }
  validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }
  modalResumeVisible;
  modalAlreadyInscriptionVisible;
  alreadyInscription
  alreadyInscriptionMessage
  openAlreadyInscriptionModal(){
	  this.modalAlreadyInscriptionVisible = true;
	  return false;
  }
  getInscriptionByEmail(email){
	this.alreadyInscription = null;
	this.alreadyInscriptionMessage = ""
	this.inscriptionService.getItems({
		includeWhere: { user: { email: email }},
	}).subscribe(res=>{
		console.log(res)
		if(res.items.length){
			this.alreadyInscription = res.items[0];
			this.modalResumeVisible = true;
		}
		else{
			this.alreadyInscriptionMessage = "aucune inscription n'a été trouvé."
		}
	})
  }

  hasOnlySP(){
    let hasSP = _.find(this.alreadyInscription.evenementParts, item => item.type == "petitsalon_offres" );
    let hasS =  _.find(this.alreadyInscription.evenementParts, item => item.type == "petitsalon_rdv" );
    let hasD = _.find(this.alreadyInscription.evenementParts, item => item.type == "petitsalon_delivrance" );
    return hasSP  && !hasD
  }
  hasOnlyD(){
    let hasSP = _.find(this.alreadyInscription.evenementParts, item => item.type == "petitsalon_offres" );
    let hasS =  _.find(this.alreadyInscription.evenementParts, item => item.type == "petitsalon_rdv" );
    let hasD = _.find(this.alreadyInscription.evenementParts, item => item.type == "petitsalon_delivrance" );
    return hasD && !hasSP
  }
  hasOnlySPD(){
    let hasSP = _.find(this.alreadyInscription.evenementParts, item => item.type == "petitsalon_offres" );
    let hasS =  _.find(this.alreadyInscription.evenementParts, item => item.type == "petitsalon_rdv" );
    let hasD = _.find(this.alreadyInscription.evenementParts, item => item.type == "petitsalon_delivrance" );
    return hasD && hasSP
  }
  nextStep() {
    console.log(this.formCheck)
    if (this.canNextStep) {
      if (this.currentUser) {
        // update user
        let form = _.clone(this.inscriptionService.form.user);
        form.id = this.currentUser.id;

        this.usersService.saveItem(form).subscribe((res) => {
          // ok
          this.authenticationService.verify();
        });
      }

      this.onNextStep.emit(this.inscriptionService.form.user);
    } else this.checkCanNextStep(null, true,()=>{
      this.nextStep()
    });
  }
  prevStep(){
      this.onPrevStep.emit()
  }
  close() {
    this.onClose.emit(this.inscriptionService.form.user);
  }
}
